// client/src/features/auth/PersistLogin.js

import {
  Outlet,
  Link,
} from 'react-router-dom';

import {
  useEffect,
  useRef,
} from 'react';

import {
  useRefreshMutation,
} from './authApiSlice';

import usePersist from '../../hooks/usePersist';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  selectCurrentToken,
  setCredentials,
} from './authSlice';

import PulseLoader from 'react-spinners/PulseLoader';


const PersistLogin = () => {
  const [persist] =
    usePersist();

  const dispatch =
    useDispatch();

  const token =
    useSelector(
      selectCurrentToken
    );

  const effectRan =
    useRef(false);

  const [
    refresh,
    {
      isLoading,
      isError,
      error,
    },
  ] = useRefreshMutation();


  useEffect(() => {
    /*
     * Prevent duplicate refresh requests caused by
     * React 18 StrictMode in development.
     */
    if (effectRan.current) {
      return;
    }

    effectRan.current = true;


    const verifyRefreshToken =
      async () => {
        console.log(
          'verifying refresh token'
        );

        try {
          /*
           * Wait for the refresh response AND grab the
           * returned access token here.
           */
          const data =
            await refresh().unwrap();

          if (!data?.accessToken) {
            throw new Error(
              'Refresh succeeded but no access token was returned'
            );
          }

          /*
           * Put the refreshed token into Redux here,
           * before allowing protected routes to render.
           */
          dispatch(
            setCredentials({
              accessToken:
                data.accessToken,
            })
          );

          console.log(
            'refresh token verified; access token restored'
          );
        } catch (err) {
          console.error(
            'Refresh token verification failed:',
            err
          );
        }
      };


    /*
     * A full browser refresh clears the Redux access
     * token because Redux is in memory.
     *
     * If this is a trusted device, restore the session
     * using the HTTP-only refresh-token cookie.
     */
    if (
      persist &&
      !token
    ) {
      verifyRefreshToken();
    }
  }, [
    persist,
    token,
    refresh,
    dispatch,
  ]);


  /*
   * Persistence disabled:
   * don't attempt session restoration.
   */
  if (!persist) {
    return <Outlet />;
  }


  /*
   * THIS is the condition that matters.
   *
   * Protected routes are only allowed to render once
   * Redux actually contains an access token.
   */
  if (token) {
    return <Outlet />;
  }


  /*
   * Refresh failed.
   */
  if (isError) {
    return (
      <p className="errmsg">
        {
          error?.data?.message ||
          'Your session has expired'
        }

        {' - '}

        <Link to="/login">
          Please login again
        </Link>
        .
      </p>
    );
  }


  /*
   * persist=true but token hasn't been restored yet.
   *
   * Stay here instead of rendering RequireAuth early.
   */
  return (
    <PulseLoader
      color="#FFF"
    />
  );
};


export default PersistLogin;